import { render, staticRenderFns } from "./CustomerUpdateSidebar.vue?vue&type=template&id=38150ed8&scoped=true&"
import script from "./CustomerUpdateSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerUpdateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUpdateSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerUpdateSidebar.vue?vue&type=style&index=1&id=38150ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38150ed8",
  null
  
)

export default component.exports